import React, { ReactNode } from 'react';

import classes from './ErrorState.module.scss';
import alertLaptopImg from '../../assets/image/alertLaptop.png';

type ErrorStateProps = {
  title: string;
  description: ReactNode;
  children?: ReactNode;
};

const ErrorState = ({ title, description, children }: ErrorStateProps) => {
  return (
    <div className={classes.container}>
      <img src={alertLaptopImg} alt="Error illustration" className={classes.image} />
      <div className={classes.content}>
        <h2 className={classes.title}>{title}</h2>
        <div className={classes.description}>{description}</div>
      </div>
      {children && <div className={classes.buttonContainer}>{children}</div>}
    </div>
  );
};

export { ErrorState };
